import { Box, Modal } from '@mui/material';
import { ClientControllerAction, ClientControllerState } from '../../controller/client-controller';
import { ClientModalChildrenData } from '../../data/client-modal-child';
import { ClientModalNames } from '../../data/client-modal-name';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';

const ClientModalView = ({
  ctrl,
  alert,
}: {
  ctrl: ClientControllerState & ClientControllerAction;
  alert: CustomAlertAction & CustomAlertState;
}) => {
  var model =
    ClientModalChildrenData.filter(
      (item) => ctrl?.activeModal !== null && item.name.includes(ctrl?.activeModal?.name)
    )[0] ?? null;
  return (
    <Modal
      open={ctrl.activeModal != null}
      onClose={(_e, reason) => {
        if (
          (reason === 'backdropClick' || reason === 'escapeKeyDown') &&
          ctrl.activeModal?.name === ClientModalNames.CREATE
        ) return;
        ctrl.onHandleModal(null);
      }}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          width: '100%',
          maxWidth: '900px',
          borderRadius: '12px',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <Box>{model != null ? <model.child ctrl={ctrl} alert={alert} /> : null}</Box>
      </Box>
    </Modal>
  );
};

export default ClientModalView;
